import React, { use, useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { Bar } from "react-chartjs-2";
import allTeams from "../../data/teams";
import { Chart as ChartJS } from "chart.js/auto"; // Tout est déjà enregistré
import { TeamContext } from "../context/TeamContext";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import { visuallyHidden } from "@mui/utils";
import { Height } from "@mui/icons-material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import green from "@mui/material/colors/green";

const tableStyling = {
  padding: "2px 5px",
  lineHeight: "1.75rem",
  textAlign: "center" as const,
  fontSize: "12px",
  height: "38px",
};

const smallCell = {
  width: "35px !important",
};

const bigCell = {
  width: "145px",
  textAlign: "left" as const,
};

const headerTable = {
  backgroundColor: "#f5f5f5",
  borderBottom: "2px solid #e0e0e0",
  FontWeight: "900",
};

const renderTeamsStanding = (
  filterType: string,
  filterName: string,
  teamsStanding: any,
  playoffCutoffOrSetter?: number,
  limit?: number,
) => {
  let filteredTeams;

  switch (filterType) {
    case "wildcard":
      filteredTeams = teamsStanding
        .filter(
          (team) =>
            team.conferenceName == filterName && team.wildcardSequence > 0,
        ) // Filter by division or conference
        .slice(0, limit); // Apply limit if provided
      break;

    case "league":
      filteredTeams = teamsStanding; // Include all teams for league
      break;

    case "division":
    case "conference":
      filteredTeams = teamsStanding
        .filter((team) => team[`${filterType}Name`] === filterName) // Filter by division or conference
        .slice(0, limit); // Apply limit if provided
      break;

    default:
      filteredTeams = []; // Default to an empty array if filterType is unknown
      break;
  }

  return (
    <div className={`divisionWrapper ${filterType}`}>
      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ ...headerTable }}>
            <TableRow>
              <TableCell sx={{ ...smallCell, ...tableStyling }}>Rank</TableCell>
              <TableCell sx={{ ...tableStyling, ...bigCell }}>Team</TableCell>
              <TableCell sx={{ ...tableStyling }}>GP</TableCell>
              <TableCell sx={{ ...tableStyling }}>W</TableCell>
              <TableCell sx={{ ...tableStyling }}>L</TableCell>
              <TableCell sx={{ ...tableStyling }}>OT</TableCell>
              <TableCell sx={{ ...tableStyling }}>PTS</TableCell>
              <TableCell sx={{ ...tableStyling }}>P%</TableCell>
              <TableCell sx={{ ...tableStyling }}>RW</TableCell>
              <TableCell sx={{ ...tableStyling }}>ROW</TableCell>
              <TableCell sx={{ ...tableStyling }}>GF</TableCell>
              <TableCell sx={{ ...tableStyling }}>GA</TableCell>
              <TableCell sx={{ ...tableStyling }}>DIFF</TableCell>
              <TableCell sx={{ ...tableStyling }}>HOME</TableCell>
              <TableCell sx={{ ...tableStyling }}>AWAY</TableCell>
              <TableCell sx={{ ...tableStyling }}>S/O</TableCell>
              <TableCell sx={{ ...tableStyling }}>L10</TableCell>
              <TableCell sx={{ ...tableStyling }}>STRK</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredTeams.map((team, index) => {
              const maxPossiblePoints =
                team.points + (82 - team.gamesPlayed) * 2;

              // Use clinchIndicator from API data
              // "p" = clinched playoffs, "y" = clinched division/conference, "x" = clinched playoffs
              const hasClinched =
                team.clinchIndicator === "p" ||
                team.clinchIndicator === "y" ||
                team.clinchIndicator === "x";

              // Team is eliminated if clinchIndicator is "e"
              const isEliminated = team.clinchIndicator === "e";

              // Debug logging
              console.log(`${team.teamCommonName.default}:`, {
                currentPoints: team.points,
                clinchIndicator: team.clinchIndicator,
                isEliminated,
                hasClinched,
              });

              console.log(
                "isEliminated:",
                isEliminated,
                "hasClinched:",
                hasClinched,
                "team:",
                team.teamCommonName.default,
              );
              return (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor: isEliminated
                      ? "rgb(200, 200, 200)"
                      : "rgb(245, 245, 245)",
                  }}
                >
                  <TableCell sx={{ ...tableStyling }}>
                    {team[`${filterType}Sequence`]}
                  </TableCell>
                  <TableCell sx={{ ...tableStyling, ...bigCell }}>
                    <Link
                      to={`/team/${team.teamAbbrev.default}`}
                      style={{ textDecoration: "none", color: "black" }}
                      key={team.id}
                    >
                      <div className="teamName">
                        <div>
                          <img
                            width={25}
                            src={`https://assets.nhle.com/logos/nhl/svg/${team.teamAbbrev.default}_light.svg`}
                            alt={`${team.teamCommonName.default} logo`}
                          />
                        </div>
                        <div>{team.teamCommonName.default}</div>
                        <div>
                          {hasClinched && (
                            <CheckBoxIcon
                              sx={{
                                color: "#888888",
                                fontSize: 16,
                                float: "right",
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </Link>
                  </TableCell>
                  <TableCell sx={{ ...tableStyling }}>
                    {team.gamesPlayed}
                  </TableCell>
                  <TableCell sx={{ ...tableStyling }}>{team.wins}</TableCell>
                  <TableCell sx={{ ...tableStyling }}>{team.losses}</TableCell>
                  <TableCell sx={{ ...tableStyling }}>
                    {team.otLosses}
                  </TableCell>
                  <TableCell sx={{ ...tableStyling }}>
                    <b>{team.points}</b>
                  </TableCell>
                  <TableCell sx={{ ...tableStyling }}>
                    {team.pointPctg.toFixed(3)}
                  </TableCell>
                  <TableCell sx={{ ...tableStyling }}>
                    {team.regulationWins}
                  </TableCell>
                  <TableCell sx={{ ...tableStyling }}>
                    {team.regulationPlusOtWins}
                  </TableCell>
                  <TableCell sx={{ ...tableStyling }}>{team.goalFor}</TableCell>
                  <TableCell sx={{ ...tableStyling }}>
                    {team.goalAgainst}
                  </TableCell>
                  <TableCell sx={{ ...tableStyling }}>
                    {team.goalDifferential}
                  </TableCell>
                  <TableCell sx={{ ...tableStyling }}>
                    {team.homeWins}-{team.homeLosses}-{team.homeOtLosses}
                  </TableCell>
                  <TableCell sx={{ ...tableStyling }}>
                    {team.roadWins}-{team.roadLosses}-{team.roadOtLosses}
                  </TableCell>
                  <TableCell sx={{ ...tableStyling }}>
                    {team.shootoutWins}-{team.shootoutLosses}
                  </TableCell>
                  <TableCell sx={{ ...tableStyling }}>
                    {team.l10Wins}-{team.l10Losses}-{team.l10OtLosses}
                  </TableCell>
                  <TableCell sx={{ ...tableStyling }}>
                    {team.streakCount}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default renderTeamsStanding;
